<h2 mat-dialog-title>Nueva Producción</h2>

<mat-dialog-content class="restock-dialog-content">
  <mat-stepper [linear]="false" #stepper>

    <!-- PASO 1: Tipo de producción -->
    <mat-step label="Tipo" [stepControl]="paso1Form">
      <form [formGroup]="paso1Form">
        <div class="step-content">
          <mat-radio-group formControlName="tipoProduccion" class="tipo-radio-group">
            <mat-radio-button [value]="TipoProduccion.IMPRESION_3D" class="tipo-option">
              <mat-icon>view_in_ar</mat-icon>
              <span>Impresión 3D</span>
            </mat-radio-button>
            <mat-radio-button [value]="TipoProduccion.TE" class="tipo-option">
              <mat-icon>local_cafe</mat-icon>
              <span>Té</span>
            </mat-radio-button>
            <mat-radio-button [value]="TipoProduccion.MANUAL" class="tipo-option">
              <mat-icon>handyman</mat-icon>
              <span>Manual</span>
            </mat-radio-button>
          </mat-radio-group>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Observaciones (opcional)</mat-label>
            <textarea matInput formControlName="observaciones" rows="2"></textarea>
          </mat-form-field>
        </div>
        <div class="step-actions">
          <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
        </div>
      </form>
    </mat-step>

    <!-- PASO 2: Datos del material -->
    <mat-step label="Material" [stepControl]="paso2Form">
      <form [formGroup]="paso2Form">
        <div class="step-content" *ngIf="tipoProduccion === TipoProduccion.IMPRESION_3D">
          <h4>Datos del material (filamento)</h4>
          <mat-form-field appearance="outline">
            <mat-label>Kilogramos de material</mat-label>
            <input matInput type="number" formControlName="materialKg" min="0" step="0.001">
            <span matSuffix>kg</span>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Costo por kg</mat-label>
            <input matInput type="number" formControlName="costoPorKg" min="0" step="0.01">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <div class="costo-preview" *ngIf="costoTotalMaterial > 0">
            <mat-icon color="primary">calculate</mat-icon>
            <span>Costo total: <strong>{{ costoTotalMaterial | currency }}</strong></span>
          </div>
        </div>

        <div class="step-content" *ngIf="tipoProduccion === TipoProduccion.TE">
          <h4>Datos de la compra de té</h4>
          <mat-form-field appearance="outline">
            <mat-label>Kilos comprados</mat-label>
            <input matInput type="number" formControlName="kilosComprados" min="0" step="0.001">
            <span matSuffix>kg</span>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Costo por kilo</mat-label>
            <input matInput type="number" formControlName="costoPorKilo" min="0" step="0.01">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <div class="costo-preview" *ngIf="costoTotalMaterial > 0">
            <mat-icon color="primary">calculate</mat-icon>
            <span>Costo total: <strong>{{ costoTotalMaterial | currency }}</strong></span>
          </div>
        </div>

        <div class="step-content" *ngIf="tipoProduccion === TipoProduccion.MANUAL">
          <div class="manual-info">
            <mat-icon>info</mat-icon>
            <p>Para producción manual no se requieren datos de material. Puedes continuar al siguiente paso.</p>
          </div>
        </div>

        <div class="step-actions">
          <button mat-button matStepperPrevious>Atrás</button>
          <button mat-raised-button color="primary" matStepperNext>Siguiente</button>
        </div>
      </form>
    </mat-step>

    <!-- PASO 3: Productos -->
    <mat-step label="Productos">
      <div class="step-content" [formGroup]="itemsForm">
        <h4>Agregar productos al lote</h4>

        <div class="product-search">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Buscar producto</mat-label>
            <input matInput [(ngModel)]="busquedaProducto" [ngModelOptions]="{standalone: true}"
                   (input)="buscarProductos(busquedaProducto)"
                   placeholder="Código o nombre...">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <div class="product-results" *ngIf="productosResultados.length > 0">
            <mat-list dense>
              <mat-list-item *ngFor="let p of productosResultados"
                             (click)="agregarItem(p)"
                             class="product-result-item">
                <span matListItemTitle>{{ p.nombre }}</span>
                <span matListItemLine>Código: {{ p.codigo }} | Stock: {{ p.stock }}</span>
              </mat-list-item>
            </mat-list>
          </div>
          <div class="no-search-results" *ngIf="buscandoProducto">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </div>

        <!-- Sin buscar: agregar vacío -->
        <button mat-stroked-button color="primary" (click)="agregarItem()" style="margin-bottom: 12px;">
          <mat-icon>add</mat-icon> Agregar producto manualmente
        </button>

        <!-- Lista de items -->
        <div *ngIf="items.length === 0" class="empty-items">
          <mat-icon>inventory_2</mat-icon>
          <p>No hay productos agregados. Busca y selecciona productos o agrégalos manualmente.</p>
        </div>

        <div *ngFor="let item of items.controls; let i = index" [formGroup]="$any(item)" class="item-card">
          <div class="item-header">
            <span class="item-number">#{{ i + 1 }}</span>
            <mat-form-field appearance="outline" class="item-nombre">
              <mat-label>Nombre del Producto</mat-label>
              <input matInput formControlName="productoNombre" readonly placeholder="Selecciona un producto">
            </mat-form-field>
            <button mat-icon-button color="warn" (click)="eliminarItem(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div class="item-fields">
            <!-- Campos para 3D -->
            <ng-container *ngIf="tipoProduccion === TipoProduccion.IMPRESION_3D">
              <mat-form-field appearance="outline">
                <mat-label>Unidades buenas</mat-label>
                <input matInput type="number" formControlName="unidades" min="0">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Unidades dañadas</mat-label>
                <input matInput type="number" formControlName="unidadesDanadas" min="0">
              </mat-form-field>
            </ng-container>

            <!-- Campos para Té -->
            <ng-container *ngIf="tipoProduccion === TipoProduccion.TE">
              <mat-form-field appearance="outline">
                <mat-label>Gramos por bolsa</mat-label>
                <input matInput type="number" formControlName="gramos" min="1">
                <span matSuffix>g</span>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Cantidad de bolsas</mat-label>
                <input matInput type="number" formControlName="cantidad" min="1">
              </mat-form-field>
            </ng-container>

            <!-- Campos para Manual -->
            <ng-container *ngIf="tipoProduccion === TipoProduccion.MANUAL">
              <mat-form-field appearance="outline">
                <mat-label>Cantidad producida</mat-label>
                <input matInput type="number" formControlName="unidades" min="1">
              </mat-form-field>
            </ng-container>

            <mat-form-field appearance="outline">
              <mat-label>Precio de venta</mat-label>
              <input matInput type="number" formControlName="precioVenta" min="0.01" step="0.01">
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
          </div>

          <div class="item-costo" *ngIf="costoUnitario > 0">
            Costo unitario estimado: <strong>{{ costoUnitario | currency }}</strong>
          </div>
        </div>
      </div>
      <div class="step-actions">
        <button mat-button matStepperPrevious>Atrás</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="items.length === 0">
          Ver resumen
        </button>
      </div>
    </mat-step>

    <!-- PASO 4: Resumen y confirmación -->
    <mat-step label="Confirmar">
      <div class="step-content resumen-content">
        <div class="resumen-cards">
          <mat-card class="resumen-card">
            <mat-icon color="warn">attach_money</mat-icon>
            <div>
              <h4>Costo Total</h4>
              <span>{{ costoTotalMaterial | currency }}</span>
            </div>
          </mat-card>
          <mat-card class="resumen-card">
            <mat-icon color="primary">inventory_2</mat-icon>
            <div>
              <h4>Total Unidades</h4>
              <span>{{ totalUnidades }}</span>
            </div>
          </mat-card>
          <mat-card class="resumen-card">
            <mat-icon color="accent">trending_up</mat-icon>
            <div>
              <h4>Ganancia Potencial</h4>
              <span>{{ gananciaPotencial | currency }}</span>
            </div>
          </mat-card>
        </div>

        <h4>Productos a actualizar:</h4>
        <mat-list dense>
          <mat-list-item *ngFor="let item of items.controls; let i = index">
            <span matListItemTitle>{{ item.get('productoNombre')?.value || 'Producto ' + (i+1) }}</span>
            <span matListItemLine>
              {{ tipoProduccion === TipoProduccion.IMPRESION_3D ? (item.get('unidades')?.value || 0) + ' unidades' :
                 tipoProduccion === TipoProduccion.TE ? (item.get('cantidad')?.value || 0) + ' bolsas de ' + (item.get('gramos')?.value || 0) + 'g' :
                 (item.get('unidades')?.value || 0) + ' unidades' }}
              — Precio: {{ item.get('precioVenta')?.value | currency }}
            </span>
          </mat-list-item>
        </mat-list>
      </div>

      <div class="step-actions">
        <button mat-button matStepperPrevious [disabled]="isLoading">Atrás</button>
        <button mat-raised-button color="primary" (click)="confirmar()" [disabled]="isLoading || items.length === 0">
          <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
          <mat-icon *ngIf="!isLoading">check</mat-icon>
          {{ isLoading ? 'Registrando...' : 'Confirmar Producción' }}
        </button>
      </div>
    </mat-step>

  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
</mat-dialog-actions>
